import React from "react";

const Crypto = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen w-full">
            <h1 className="text-4xl font-bold text-center text-neutral-500 dark:text-neutral-300">Coming Soon!</h1>
            <p className="text-lg text-center text-neutral-500 dark:text-neutral-300">We are working on this page, please check back later.</p>
        </div>
    );
}

export default Crypto;